<template>
  <v-card>
    <popup-form
      :title="isNew ? 'New Template' : 'Edit Template'"
      v-on:close="close"
      v-on:submit="submit"
      v-on:remove="remove"
      :newObj="newObj"
    >
      <v-divider></v-divider>
      <v-container flat fluid>
        <v-row class="px-3 pt-3">
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              v-model="obj.name"
              label="Template Name"
              placeholder="Enter the name for your new template"
              outlined
              filled
              required
              :rules="[rules.required, rules.template]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" v-if="newObj" class="py-0">
            <v-select
              label="Predefined Templates"
              placeholder="Select from existing templates"
              v-model="predefined"
              :items="defaultTemplates"
              outlined
              filled
              return-object
              item-text="name"
              clearable
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-tabs
        show-arrows
        v-model="tab"
        background-color="grey lighten-5"
        color="primary"
        center-active
      >
        <v-tab v-for="(item, index) in tabItems" :key="index">{{ item }}</v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="tab">
        <v-tab-item v-if="type == 'Candidate'">
          <roles :obj="obj" :template="true"></roles>
        </v-tab-item>
        <v-tab-item>
          <attributes :obj="obj" :template="true"></attributes>
        </v-tab-item>
        <v-tab-item>
          <documents :obj="obj" :template="true"></documents>
        </v-tab-item>
      </v-tabs-items>
    </popup-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import roles from '@/components/roles';
import attributes from '@/components/attributes';
import documents from '@/components/documents';

export default {
  props: {
    template: Object,
    newObj: Boolean,
    type: String,
    isPredefined: Boolean
  },
  components: {
    roles,
    attributes,
    documents
  },
  data() {
    return {
      obj: {
        name: '',
        roles: [],
        attributes: [{}],
        documents: [{}]
      },

      tab: 0,
      predefined: null,
      rules: {
        none: value => value,
        required: value => !!value || 'Field Required',
        template: value => !!value || 'Field Required'
        // template: value => value != 'Default' || 'Default is reserved'
      }
    };
  },
  computed: {
    ...mapState({
      templates: state => state.templates,
      account: state => state.account
    }),
    defaultTemplates() {
      return this.templates.items.filter(template => {
        return template.predefined && template.type == this.type;
      });
    },
    user() {
      console.log(this.account.user);
      return this.account.user;
    },
    isNew() {
      return !this.template;
    },
    canSave() {
      return true;
    },
    tabItems() {
      var tabs = ['Attributes', 'Documents'];
      if (this.type == 'Candidate') {
        tabs.unshift('Roles');
      }
      return tabs;
    }
  },
  watch: {
    obj: {
      handler: function(val, oldVal) {
        this.cleanObj(val);
      },
      deep: true
    },
    predefined(val) {
      if (val) {
        this.obj.name = val.name;
        this.obj.roles = val.roles;
        this.obj.attributes = val.attributes;
        this.obj.documents = val.documents;
      }
    }
  },
  methods: {
    ...mapActions({
      createTemplate: 'templates/create',
      updateTemplate: 'templates/update',
      deleteTemplate: 'templates/delete'
    }),
    close() {
      this.$emit('close');
    },
    submit() {
      console.log(this.obj);
      this.newObj ? this.create() : this.update();
    },
    async create() {
      await this.createTemplate(this.obj);
      this.close();
    },
    async update() {
      await this.updateTemplate(this.obj);
      this.close();
    },
    async remove() {
      await this.deleteTemplate(this.obj._id);
      this.close();
    }
  },
  mounted() {
    if (this.template) {
      this.obj = this.template;
    }
    if (this.isPredefined) {
      this.obj.predefined = this.isPredefined;
    }
    if (this.type) {
      this.obj.type = this.type;
    }
  }
};
</script>
